import { render, staticRenderFns } from "./mg-confirm.vue?vue&type=template&id=1009516c&scoped=true&"
import script from "./mg-confirm.vue?vue&type=script&lang=js&"
export * from "./mg-confirm.vue?vue&type=script&lang=js&"
import style0 from "./mg-confirm.vue?vue&type=style&index=0&id=1009516c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1009516c",
  null
  
)

export default component.exports